import React from 'react';
import styles from '../../pages/Pages.module.css';
import { Col } from 'antd';
import useGiideList from '../../hooks/useQuery/useGiideList';
import useGiideListPagination from '../../hooks/useGiideListPagination';
import GiideCard from './GiideCard';

const GiideListGrid: React.FC = () => {
  const { sortedData } = useGiideList(true);
  const { paginationPage } = useGiideListPagination();

  return (
    <Col className={styles.giideCardCol}>
      {sortedData
        ?.slice(
          paginationPage!.paginationState.minValue,
          paginationPage!.paginationState.maxValue
        )
        .map(giide => (
          <GiideCard key={giide.id} {...giide} />
        ))}
    </Col>
  );
};

export default GiideListGrid;
